// layouts

import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout

import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";

// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";

// views without layouts

import Landing from "@/views/Landing.vue";
import Profile from "@/views/Profile.vue";
// import Index from "@/views/Index.vue";

import { useUserStore } from '@/stores/user';

import { UserManagementView } from '@/views/admin/user-management';
import { RoleManagementView } from '@/views/admin/role-management';
import { ClientManagementView, AddClientManagementView, EditClientManagementView, ReportClientManagementView } from '@/views/admin/clients';
import { ApiManagementView, AddApiManagementView, EditApiManagementView, ShowApiManagementView, UseApiRequestView, BulkApiManagementView } from '@/views/admin/api-management';
import { PricingView, AddPricingView, EditPricingView, DetailPricingView } from '@/views/admin/pricings';
import { ApiPlaygroundView } from '@/views/admin/api-playground';
import { ApiRequestView, AddApiRequestView, EditApiRequestView } from '@/views/admin/api-request';
import ChangePasswordView from '@/views/ChangePassword.vue';

const routes = [
    {
        path: "/admin",
        redirect: "/admin/dashboard",
        component: Admin,
        children: [
            {
                path: "/admin/dashboard",
                component: Dashboard,
                // meta: {
                //     requiresAuth: false
                // }
            },
            {
                path: "/admin/user-management",
                component: UserManagementView,
            },
            {
                path: "/admin/role-management",
                component: RoleManagementView,
            },
            {
                path: "/profile",
                component: Settings,
            },
            {
                path: "/admin/clients",
                component: ClientManagementView,
            },
            {
                path: "/admin/clients/new",
                component: AddClientManagementView,
            },
            {
                path: "/admin/clients/:id/edit",
                component: EditClientManagementView,
            },
            {
                path: "/admin/clients/:id/reports",
                component: ReportClientManagementView,
            },
            {
                path: "/admin/api-management",
                component: ApiManagementView,
            },
            {
                path: "/admin/api-management/new",
                component: AddApiManagementView,
            },
            {
                path: "/admin/api-management/:id",
                component: ShowApiManagementView
            },
            {
                path: "/admin/api-management/:id/edit",
                component: EditApiManagementView,
            },
            {
                path: "/admin/pricings",
                component: PricingView,
            },
            {
                path: "/admin/pricings/new",
                component: AddPricingView,
            },
            {
                path: "/admin/pricings/:id",
                component: DetailPricingView
            },
            {
                path: "/admin/pricings/:id/edit",
                component: EditPricingView,
            },
            {
                path: "/admin/api-playground",
                component: ApiPlaygroundView,
            },
            {
                path: "/change-password",
                component: ChangePasswordView,
            },
            {
                path: "/admin/api-requests",
                component: ApiRequestView,
            },
            {
                path: "/admin/api-requests/new",
                component: AddApiRequestView,
            },
            {
                path: "/admin/api-requests/:id/edit",
                component: EditApiRequestView,
            },
            {
                path: "/admin/api-management/:id/use",
                component: UseApiRequestView,
            },
            {
                path: "/admin/api-management/bulk",
                component: BulkApiManagementView,
            }
        ],
    },
    {
        path: "/auth",
        redirect: "/auth/login",
        component: Auth,
        children: [
            {
                path: "/auth/login",
                component: Login,
                meta: {
                    skipAuth: true
                }
            },
            {
                path: "/auth/register",
                component: Register,
                meta: {
                    skipAuth: true
                }
            },
        ],
    },
    {
        path: "/landing",
        component: Landing,
    },
    {
        path: "/profile",
        component: Profile,
    },
    {
        path: "/",
        redirect: () => {
            // the function receives the target route as the argument
            // a relative location doesn't start with `/`
            // or { path: 'profile'}
            const auth = useUserStore();
            if (!auth.user) {
                return '/auth/login'
            } else {
                return '/admin/dashboard'
            }

        },
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
];

import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const auth = useUserStore();
    if (!to.matched.some((record) => record.meta.skipAuth) && !auth.user) {
        /* if (false) {
             next();
             return;
         }*/
        next("/auth/login");
    } else {
        next();
    }
});

// router.beforeEach(async (to) => {
//     // redirect to login page if not logged in and trying to access a restricted page
//     const publicPages = ['/auth/login'];
//     const authRequired = !publicPages.includes(to.path);
//     const auth = useUserStore();

//     if (authRequired && !auth.user) {
//         auth.returnUrl = to.fullPath;
//         return '/auth/login';
//     }else{
//         next
//     }
// });

export default router;
